import { environment } from '@/config/environment';

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const LOG_LEVELS: Record<LogLevel, number> = {
  debug: 0,
  info: 1,
  warn: 2,
  error: 3,
};

class Logger {
  private isEnabled: boolean;
  private currentLevel: number;

  constructor() {
    this.isEnabled = environment.ENABLE_CONSOLE_LOGS;
    this.currentLevel = LOG_LEVELS[environment.LOG_LEVEL as LogLevel];
  }

  private shouldLog(level: LogLevel): boolean {
    return this.isEnabled && LOG_LEVELS[level] >= this.currentLevel;
  }

  debug(...args: any[]): void {
    if (this.shouldLog('debug')) {
      console.debug(...args);
    }
  }

  info(...args: any[]): void {
    if (this.shouldLog('info')) {
      console.info(...args);
    }
  }

  warn(...args: any[]): void {
    if (this.shouldLog('warn')) {
      console.warn(...args);
    }
  }

  error(...args: any[]): void {
    if (this.shouldLog('error')) {
      console.error(...args);
    }
  }

  log(...args: any[]): void {
    if (this.shouldLog('info')) {
      console.log(...args);
    }
  }
}

// Create singleton instance
const logger = new Logger();

// Export the logger instance
export default logger;

// Also export individual methods for convenience
export const { debug, info, warn, error, log } = logger;
